module.exports = __webpack_public_path__ + "static/json-a1a6e92a7c7e4817178ff923c8f3fdb5.png";